import { createAsyncThunk as createAsyncThunkDefault } from '@reduxjs/toolkit'
import { TAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { IState } from 'legacy/lut/store'

type TCreateAsyncThunk = {
  state: IState
  dispatch: TAppDispatch
}

export const createAsyncThunk = createAsyncThunkDefault.withTypes<TCreateAsyncThunk>()
